/* DeviceCaptureStatusRenderer.js */

"use strict";
const captureStatuses = require("../../deviceConstants").DEVICE_CAPTURE_STATUSES;

class DeviceCaptureStatusColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("device-capture-status-column");
        this._rootElem.component = this._model;

        this._deviceStatuses = captureStatuses;
        this._statusIcon = document.createElement("base-icon-gl");

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._statusIcon.remove();
            this._statusIcon = undefined;
            this._deviceStatuses = undefined;

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("CaptureStatus", (this._onCaptureStatus = this._onCaptureStatus.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("CaptureStatus");
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setCaptureStatus(this._model.getCaptureStatus());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onCaptureStatus(newVal) {
        this._setCaptureStatus(newVal);
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setCaptureStatus(newVal = "UNKNOWN") {
        const captureStatus = this._deviceStatuses[newVal];
        if (captureStatus) {
            this._updateIcon(captureStatus);
            if (!this._rootElem.contains(this._statusIcon)) {
                this._rootElem.innerHTML = "";
                this._rootElem.appendChild(this._statusIcon);
            }
        } else {
            this._rootElem.innerHTML = newVal;
        }
    }

    _updateIcon({ icon = "", title = "", name = "" } = {}) {
        this._statusIcon.dataset.icon = icon;
        this._statusIcon.setAttribute("title", title);
        this._statusIcon.setInvalid(name === "ERROR");
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = DeviceCaptureStatusColumnRenderer;
